<template>
  <div :style="{ height: OFFSETHEIGHT - 370 + 'px' }">
    <iframe
      :src="page_path"
      style="width: 100%; height: 100%"
      loading="lazy"
      frameborder="0"
      tabindex="0"></iframe>
  </div>
</template>

<script>
export default {
  props: {
    page_path: String,
  },
  data() {
    return {
      OFFSETHEIGHT: 0,
    };
  },
  mounted() {
    this.fnGetWidth();
  },
  methods: {
    fnGetWidth() {
      this.ROOTFONTFIZE = localStorage.getItem('ROOTFONTFIZE');
      this.TABPANEHEIGHT = localStorage.getItem('TABPANEHEIGHT');
      var element = document.getElementById('rootchart');
      let ROOTFONTFIZE = element.offsetWidth;
      ROOTFONTFIZE = ROOTFONTFIZE > 1440 ? 1440 : ROOTFONTFIZE;
      ROOTFONTFIZE = ROOTFONTFIZE < 1440 ? ROOTFONTFIZE - 200 : ROOTFONTFIZE;
      let OFFSETHEIGHT = element.offsetHeight;
      this.OFFSETHEIGHT = OFFSETHEIGHT;
      console.clear();
      console.log(OFFSETHEIGHT);
    },
  },
};
</script>

<style></style>
